module.exports = __webpack_public_path__ + "static/obvious_thumbnail-b3b2bbe56d5e43be0353a86d04cd9130.jpg";